import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const SyncErrorIcon = ({
  color = RoutalPalette.secondary60,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} width="21" height="20" viewBox="0 0 21 20" fill="none" style={{ ...props.style }}>
      <g fill="none">
        <path
          d="M10.834 17.5C6.69185 17.5 3.33398 14.1422 3.33398 10C3.33398 7.1545 4.91863 4.67912 7.25357 3.40818M7.25357 3.40818V3.01206H4.30729M7.25357 3.40818V5.95833M10.834 2.5C14.9762 2.5 18.334 5.85787 18.334 10C18.334 12.8455 16.7493 15.3209 14.4144 16.5918M14.4144 16.5918V16.9879H17.3607M14.4144 16.5918V14.0417"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.8301 6.5459V10.5459" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M10.8301 13.4543H10.8401"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};
